import { Link } from "react-router-dom";
import { ITAAS_INSTITUTION, ITAAS_OPERATIONAL_LEADERSHIP } from "@itaas/pep-contracts";
import { SiteLayout } from "../components/layout/SiteLayout";
import { SeoHead } from "../components/seo/SeoHead";
import { PublisherTrustStrip } from "../components/trust/InstitutionalTrust";
import { usePepI18n } from "../i18n/usePepI18n";

export function AboutPage() {
  const { locale } = usePepI18n();
  const en = locale === "en";

  return (
    <SiteLayout>
      <SeoHead
        title={en ? "About ITaaS RDC" : "À propos — ITaaS RDC"}
        description={
          en
            ? "ITaaS RDC publishes and operates ITaaS Suite from Lubumbashi, Democratic Republic of the Congo."
            : "ITaaS RDC édite et opère ITaaS Suite depuis Lubumbashi, République démocratique du Congo."
        }
        keywords={["ITaaS RDC", "ITaaS Suite", "Lubumbashi", "éditeur logiciel RDC"]}
        canonicalPath="/about"
        locale={locale}
      />

      <div className="pep-page-hero py-5 mb-0">
        <div className="container">
          <p className="text-uppercase small fw-semibold mb-2 opacity-75">
            {en ? "Company" : "Entreprise"}
          </p>
          <h1 className="display-5 fw-bold mb-3">
            {en ? "Who publishes ITaaS Suite?" : "Qui édite ITaaS Suite ?"}
          </h1>
          <p className="lead mb-0 opacity-90 col-lg-8">
            {en ? ITAAS_INSTITUTION.relationshipEn : ITAAS_INSTITUTION.relationshipFr}
          </p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-7">
            <h2 className="h4 fw-bold mb-3">{en ? "ITaaS RDC" : "ITaaS RDC"}</h2>
            <p>
              {en
                ? "ITaaS RDC (legal name: INFORMATION TECHNOLOGY AS A SERVICE RDC SARL) is a Congolese technology company. We design, publish and operate business software for organisations in the DRC and Central Africa."
                : "ITaaS RDC (raison sociale : INFORMATION TECHNOLOGY AS A SERVICE RDC SARL) est une entreprise technologique congolaise. Nous concevons, éditons et opérons des logiciels métier pour les organisations en RDC et en Afrique centrale."}
            </p>
            <h2 className="h4 fw-bold mb-3 mt-4">{en ? "ITaaS Suite" : "ITaaS Suite"}</h2>
            <p>
              {en
                ? "ITaaS Suite is our product portfolio — modular applications for HR, education, health, inventory, finance and more — delivered through this Product Experience Platform."
                : "ITaaS Suite est notre portefeuille de produits — applications modulaires pour la RH, l’éducation, la santé, le stock, la finance et d’autres domaines — présenté sur cette plateforme d’expérience produit."}
            </p>
            <p className="mb-0">
              <a
                className="btn btn-outline-primary"
                href={ITAAS_INSTITUTION.institutionalWebsite}
                rel="noopener noreferrer"
              >
                {en ? "Institutional website" : "Site institutionnel"} — itaas-rdc.com
              </a>
            </p>
          </div>
          <div className="col-lg-5">
            <div className="card border-0 shadow-sm p-4 h-100">
              <h2 className="h6 text-uppercase text-secondary mb-3">
                {en ? "Contact" : "Coordonnées"}
              </h2>
              <PublisherTrustStrip compact />
              <ul className="list-unstyled small mt-3 mb-0">
                {ITAAS_INSTITUTION.address.displayLines.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
              <p className="small mt-3 mb-1">
                <a href={`mailto:${ITAAS_INSTITUTION.email}`}>{ITAAS_INSTITUTION.email}</a>
              </p>
              <p className="small mb-3">
                <a href={`tel:${ITAAS_INSTITUTION.telephoneTel}`}>{ITAAS_INSTITUTION.telephone}</a>
              </p>
              <Link className="small" to="/contact">
                {en ? "Commercial contact form →" : "Formulaire contact commercial →"}
              </Link>
            </div>
          </div>
        </div>

        <section className="mt-5 pt-4 border-top" aria-labelledby="leadership-heading">
          <h2 id="leadership-heading" className="h4 fw-bold mb-2">
            {en ? "Operational leadership" : "Direction opérationnelle"}
          </h2>
          <p className="text-secondary small mb-4 col-lg-8">
            {en
              ? "Public operational roles. These titles do not imply statutory directorship or RCCM mandates."
              : "Rôles opérationnels publics. Ces intitulés n’impliquent pas de qualité de gérant statutaire ni de mandat RCCM."}
          </p>
          <div className="row g-3">
            {ITAAS_OPERATIONAL_LEADERSHIP.map((person) => (
              <div className="col-md-6 col-lg-4" key={person.name}>
                <div className="border rounded-3 p-3 h-100">
                  <p className="fw-semibold mb-1">{person.name}</p>
                  <p className="small text-secondary mb-0">
                    {en ? person.titleEn : person.titleFr}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}
